// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hMa1z{display:-webkit-box;display:flex}.W7_63{-webkit-box-pack:justify;justify-content:space-between}.r728t{-webkit-box-pack:center;gap:.5rem;justify-content:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.WsOwA{visibility:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `hMa1z`,
	"root_apart": `W7_63`,
	"root_together": `r728t`,
	"root_invisible": `WsOwA`
};
module.exports = ___CSS_LOADER_EXPORT___;
